<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header crm-page" [class.crm-page--kanban-expanded]="kanbanExpanded && activeTab === 'kanban'">

  <!-- ===== PAGE HEADER ===== -->
  <div class="container-header-inner-list crm-page-top">

    <!-- Title row -->
    <div class="row mb-4 crm-page-top__collapsible">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">CRM — Oportunidades</h1>
            <p class="welcome-message">Acompanhe o funil comercial e mova negócios entre etapas</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
          <span>Ações</span>
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #acoesMenu="matMenu">
          <button mat-menu-item (click)="exportar()">
            <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
            <span>Exportar lista para planilha</span>
          </button>
        </mat-menu>

        <button mat-flat-button class="btn-primary" (click)="novaOportunidade()">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Nova Oportunidade
        </button>
      </div>
    </div>

    <!-- Search + pills + filter row -->
    <div class="row search-area g-3 crm-page-top__collapsible" [formGroup]="filterModel">
      <div class="col-xl-5 col-lg-5 col-12">
        <mat-form-field appearance="outline" class="filter-pesquisa" subscriptSizing="dynamic">
          <mat-label>Pesquisar</mat-label>
          <input matInput placeholder="Pesquise por cliente ou assunto…" formControlName="searchText" />
          <button mat-icon-button matSuffix type="button">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="col-xl-7 col-lg-7 col-12">
        <div class="filter-actions">

          <!-- Pill: Período -->
          <button mat-stroked-button type="button" class="btn-filter crm-pill"
            [class.crm-pill--on]="periodoDestacado"
            [matMenuTriggerFor]="periodoMenu" #periodoTrigger="matMenuTrigger"
            (menuOpened)="intervaloAberto = periodo === 'intervalo'">
            <mat-icon class="material-symbols-outlined">calendar_month</mat-icon>
            {{ periodoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>

          <!-- Padrão de período do sistema: "do intervalo" é um item da lista e só ele abre as datas. -->
          <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="intervaloAberto = false">
            <div class="periodo-menu-content">
              @for (opcao of periodoOpcoes; track opcao.value) {
                @if (opcao.value === 'intervalo') {
                  <button type="button" class="periodo-menu-item" [class.periodo-item-selecionado]="intervaloAberto"
                    (click)="intervaloAberto = true; $event.stopPropagation()">
                    <span>{{ opcao.label }}</span>
                    @if (intervaloAberto) { <mat-icon>check</mat-icon> }
                  </button>
                } @else {
                  <button type="button" class="periodo-menu-item"
                    [class.periodo-item-selecionado]="!intervaloAberto && periodo === opcao.value"
                    (click)="selecionarPeriodo(opcao.value)">
                    <span>{{ opcao.label }}</span>
                    @if (!intervaloAberto && periodo === opcao.value) { <mat-icon>check</mat-icon> }
                  </button>
                }
              }

              @if (intervaloAberto) {
                <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline">
                    <mat-label>De</mat-label>
                    <input matInput [matDatepicker]="dpDe" [(ngModel)]="intervaloDe" placeholder="DD/MM/AAAA"
                      [ngModelOptions]="{ standalone: true }" />
                    <mat-datepicker-toggle matIconSuffix [for]="dpDe"></mat-datepicker-toggle>
                    <mat-datepicker #dpDe></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Até</mat-label>
                    <input matInput [matDatepicker]="dpAte" [(ngModel)]="intervaloAte" placeholder="DD/MM/AAAA"
                      [ngModelOptions]="{ standalone: true }" />
                    <mat-datepicker-toggle matIconSuffix [for]="dpAte"></mat-datepicker-toggle>
                    <mat-datepicker #dpAte></mat-datepicker>
                  </mat-form-field>

                  <div class="periodo-intervalo-actions">
                    <button type="button" mat-button class="btn-secondary"
                      (click)="cancelarIntervalo(); periodoTrigger.closeMenu()">Cancelar</button>
                    <button type="button" mat-flat-button class="btn-primary" [disabled]="!intervaloDe || !intervaloAte"
                      (click)="aplicarIntervalo(); periodoTrigger.closeMenu()">Aplicar</button>
                  </div>
                </div>
              }
            </div>
          </mat-menu>

          <!-- Pill: Visão -->
          <button mat-stroked-button type="button" class="btn-filter crm-pill"
            [class.crm-pill--on]="visaoDestacada"
            [matMenuTriggerFor]="visaoMenu">
            <mat-icon class="material-symbols-outlined">visibility</mat-icon>
            {{ visaoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>

          <mat-menu #visaoMenu="matMenu" class="filter-custom-menu">
            @for (opcao of visaoOpcoes; track opcao.value) {
              <button mat-menu-item (click)="selecionarVisao(opcao.value)">
                <mat-icon class="material-symbols-outlined crm-menu-check"
                  [class.crm-menu-check--on]="visao === opcao.value">check</mat-icon>
                <span>{{ opcao.label }}</span>
              </button>
            }
          </mat-menu>

          <!-- Filtros avançados -->
          <button mat-stroked-button type="button" class="btn-filter"
            [matBadge]="qtdFiltrosAvancados"
            [matBadgeHidden]="qtdFiltrosAvancados === 0"
            [matMenuTriggerFor]="filtroMenu">
            <mat-icon class="material-symbols-outlined">filter_list</mat-icon>
            Filtrar
          </button>

          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="filterModel">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros</h6>
                <div class="filter-menu__form">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Vendedor responsável</mat-label>
                    <mat-select formControlName="filterRespId">
                      <mat-option [value]="null">Todos</mat-option>
                      @for (v of vendedoresFiltro; track v.idVendedor) {
                        <mat-option [value]="v.idVendedor">{{ v.nome }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Responsável pela próxima ação</mat-label>
                    <mat-select formControlName="filterRespAcaoId">
                      <mat-option [value]="null">Todos</mat-option>
                      @for (u of peopleList; track u.idUsuario) {
                        <mat-option [value]="u.idUsuario">{{ u.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Origem do lead</mat-label>
                    <mat-select formControlName="filterOrigem">
                      <mat-option [value]="null">Todas</mat-option>
                      @for (o of origens; track o.id) {
                        <mat-option [value]="o.id">{{ o.descricao }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Faixa de valor estimado</mat-label>
                    <mat-select formControlName="filterFaixaValor">
                      <mat-option value="">Todas</mat-option>
                      @for (f of faixaValorOpcoes; track f.value) {
                        <mat-option [value]="f.value">{{ f.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Prioridade</mat-label>
                    <mat-select formControlName="filterPrioridade">
                      <mat-option value="">Todas</mat-option>
                      @for (p of prioridades; track p.chave) {
                        <mat-option [value]="p.chave">{{ p.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Filtrar período por</mat-label>
                    <mat-select formControlName="filterCampoData">
                      @for (c of campoDataOpcoes; track c.value) {
                        <mat-option [value]="c.value">{{ c.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  @if (activeTab === 'lista') {
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Etapa</mat-label>
                      <mat-select formControlName="filterStage">
                        <mat-option value="">Todas</mat-option>
                        @for (s of allStages; track s.key) {
                          <mat-option [value]="s.key">{{ s.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>Aplicar</button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Filtro de cliente vindo do cadastro de Pessoa ("Ver todos no CRM") -->
    @if (idPessoaClienteFiltro != null) {
      <div class="crm-filtro-cliente crm-page-top__collapsible">
        <mat-chip-set aria-label="Filtro por cliente">
          <mat-chip (removed)="removerFiltroCliente()">
            Cliente: {{ nomeClienteFiltro }}
            <button matChipRemove type="button" [attr.aria-label]="'Remover filtro do cliente ' + nomeClienteFiltro"
              matTooltip="Remover filtro do cliente">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-set>
      </div>
    }

    <!-- Faixa de escopo: só aparece quando há restrição de verdade. Fica acima das abas porque
         diz respeito ao que o usuário enxerga nas duas visões. -->
    @if (textoEscopo) {
      <div class="crm-escopo crm-page-top__collapsible">
        <mat-icon class="material-symbols-outlined">visibility</mat-icon>
        {{ textoEscopo }}
      </div>
    }

    <!-- Tab bar -->
    <div class="crm-tabs-bar">
      <button #tabBtnKanban class="crm-tab" [class.crm-tab--active]="activeTab === 'kanban'"
        (click)="selecionarAba('kanban')">
        <mat-icon class="material-symbols-outlined">view_kanban</mat-icon>
        Kanban
      </button>
      <button #tabBtnLista class="crm-tab" [class.crm-tab--active]="activeTab === 'lista'"
        (click)="selecionarAba('lista')">
        <mat-icon class="material-symbols-outlined">list</mat-icon>
        Lista
      </button>
      <span class="crm-tab-indicator"
        [style.transform]="'translateX(' + indicadorX + 'px)'"
        [style.width.px]="indicadorW"></span>
      <span class="crm-tab-spacer"></span>
      <span class="crm-tab-count">
        <b>{{ totalCardsVisiveis }}</b> {{ contadorSubstantivo }}
      </span>
      @if (activeTab === 'kanban') {
        @if (kanbanExpanded) {
          <button mat-flat-button class="btn-primary crm-tabs-acao" (click)="novaOportunidade()">
            <mat-icon class="material-symbols-outlined">add</mat-icon>
            Oportunidade
          </button>
        }
        <button mat-stroked-button type="button" class="btn-secondary crm-expand-btn"
          (click)="toggleKanbanExpand()"
          [matTooltip]="kanbanExpanded ? 'Recolher cabeçalho' : 'Expandir kanban'">
          <mat-icon class="material-symbols-outlined">
            {{ kanbanExpanded ? 'close_fullscreen' : 'open_in_full' }}
          </mat-icon>
          {{ kanbanExpanded ? 'Recolher' : 'Expandir' }}
        </button>
      }
    </div>
  </div>

  <!-- =====================================================================
       MENU DE CONTEXTO DO CARD — um só, usado por Kanban e Lista (CA08)
       ===================================================================== -->
  <mat-menu #cardMenu="matMenu" class="crm-card-menu">
    <ng-template matMenuContent let-card="card">
      @if (getStage(card.stage).isFinal) {
        <button mat-menu-item (click)="reabrirOportunidade(card)">
          <mat-icon class="material-symbols-outlined">lock_open</mat-icon>
          <span>reabrir oportunidade</span>
        </button>
        <mat-divider></mat-divider>
      }

      <button mat-menu-item (click)="editarAssunto(card)">
        <mat-icon class="material-symbols-outlined">edit</mat-icon>
        <span>editar assunto</span>
      </button>

      <button mat-menu-item (click)="excluirAssunto(card)">
        <mat-icon class="material-symbols-outlined text-danger">delete</mat-icon>
        <span>excluir assunto</span>
      </button>

      @if (card.arquivado) {
        <button mat-menu-item (click)="desarquivarAssunto(card)">
          <mat-icon class="material-symbols-outlined">unarchive</mat-icon>
          <span>desarquivar assunto</span>
        </button>
      } @else {
        <button mat-menu-item (click)="arquivarAssunto(card)">
          <mat-icon class="material-symbols-outlined">folder</mat-icon>
          <span>arquivar assunto</span>
        </button>
      }

      <mat-divider></mat-divider>

      <div class="crm-menu-status" (click)="$event.stopPropagation()">
        <div class="crm-menu-status__label">
          <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
          Alterar status do cliente
        </div>
        <div class="crm-menu-status__opcoes">
          @for (status of statusCliente; track status.chave) {
            <!-- O span carrega o tooltip: botão desabilitado não dispara eventos de mouse. -->
            <span [matTooltip]="motivoStatusClienteSemPermissao ?? status.label">
              <button type="button" class="crm-status-dot"
                [class.crm-status-dot--on]="isStatusAtual(card, status.chave)"
                [style.color]="status.cor"
                [style.border-color]="isStatusAtual(card, status.chave) ? status.cor : 'transparent'"
                [disabled]="!!motivoStatusClienteSemPermissao"
                [attr.aria-label]="motivoStatusClienteSemPermissao ?? status.label"
                (click)="alterarStatusCliente(card, status.chave)">
                <mat-icon class="material-symbols-outlined crm-icon-filled">person</mat-icon>
              </button>
            </span>
          }
        </div>
      </div>

      <div class="crm-menu-status" (click)="$event.stopPropagation()">
        <div class="crm-menu-status__label">
          <mat-icon class="material-symbols-outlined">flag</mat-icon>
          prioridade
        </div>
        <div class="crm-menu-status__opcoes">
          @for (prio of prioridades; track prio.chave) {
            <button type="button" class="crm-prio-opcao"
              [class.crm-prio-opcao--on]="isPrioridadeAtual(card, prio.chave)"
              [matTooltip]="prio.label"
              (click)="alterarPrioridade(card, prio.chave)">
              <span class="crm-prio-dot" [style.background]="prio.cor"></span>
              {{ prio.label }}
            </button>
          }
        </div>
      </div>

      <mat-divider></mat-divider>

      <button mat-menu-item (click)="abrirPainelTags(card)">
        <mat-icon class="material-symbols-outlined">label</mat-icon>
        <span>tags</span>
      </button>
    </ng-template>
  </mat-menu>

  <!-- ===== KANBAN BOARD ===== -->
  @if (activeTab === 'kanban') {
    <div class="crm-board-wrapper">
      <div class="crm-board" [class.crm-board--no-card-animation]="suppressCardMoveAnimation" cdkDropListGroup>

        <ng-template #cardSkeleton>
          <div class="crm-card crm-card--skeleton" aria-hidden="true">
            <div class="crm-card-top">
              <app-loading-box height="10" width="120"></app-loading-box>
              <app-loading-box height="8" width="8"></app-loading-box>
            </div>
            <app-loading-box height="12" margin="0 0 8px 0"></app-loading-box>
            <app-loading-box height="10" width="110" margin="0 0 12px 0"></app-loading-box>
            <div class="crm-card-footer">
              <app-loading-box height="22" width="22"></app-loading-box>
              <app-loading-box height="9" width="62"></app-loading-box>
            </div>
          </div>
        </ng-template>

        <ng-template #colColapsada let-stage>
          <div class="crm-col-collapsed"
            [class.crm-col-collapsed--no-access]="stage.podeVisualizar === false"
            [style.border-top-color]="stage.color"
            (click)="toggleCollapsedStage(stage)"
            [matTooltip]="tooltipEtapaColapsada(stage)">
            <span class="crm-col-icon" [style.border-color]="stage.color" [style.background]="stage.tint"
              [style.color]="stage.color">
              <mat-icon class="material-symbols-outlined">{{ stage.icon }}</mat-icon>
            </span>
            <span class="crm-col-badge">{{ totalDaEtapa(stage.key) }}</span>
            <div class="crm-col-name-vertical">{{ stage.name }}</div>
            <mat-icon class="material-symbols-outlined crm-icon-muted crm-col-expandir">keyboard_double_arrow_right</mat-icon>
          </div>
        </ng-template>

        <ng-template #colExpandida let-stage>
          <div class="crm-column"
            [class.crm-column--blocked]="isDropBlocked(stage.key)"
            cdkDropList
            [cdkDropListData]="cardsByStage[stage.key]"
            [id]="'drop-' + stage.key"
            (cdkDropListDropped)="drop($event, stage.key)">

            <div class="crm-col-accent" [style.background]="stage.color"></div>

            <div class="crm-col-header">
              <span class="crm-col-icon" [style.border-color]="stage.color" [style.background]="stage.tint"
                [style.color]="stage.color">
                <mat-icon class="material-symbols-outlined">{{ stage.icon }}</mat-icon>
              </span>
              <div class="crm-col-header-info">
                <div class="crm-col-name">{{ stage.name }}</div>
                <div class="crm-col-total">R$ {{ totalValorDaEtapa(stage.key) }}</div>
              </div>
              <span class="crm-col-badge">{{ totalDaEtapa(stage.key) }}</span>
              <button class="crm-icon-btn" (click)="toggleCollapse(stage.key)" matTooltip="Recolher">
                <mat-icon class="material-symbols-outlined">keyboard_double_arrow_left</mat-icon>
              </button>
            </div>

            @if (isDropBlocked(stage.key)) {
              <div class="crm-blocked-overlay">
                <span class="crm-blocked-badge">
                  <mat-icon class="material-symbols-outlined">block</mat-icon>
                  Movimento não permitido
                </span>
              </div>
            }

            <div class="crm-cards-area">
              @for (card of colunaCards(stage.key); track card.renderKey || card.id) {
                <div class="crm-card"
                  [class.crm-card--loading]="idOportunidadeAbrindo === card.idOportunidade"
                  cdkDrag
                  [cdkDragData]="card"
                  [cdkDragDisabled]="!isDraggable(card)"
                  (cdkDragStarted)="dragStarted(card)"
                  (cdkDragEnded)="dragEnded()"
                  (click)="abrirCard(card)">

                  <!-- Cabeçalho: número + prioridade, cliente, contato, título, tags -->
                  <div class="crm-card-top">
                    <span class="crm-card-num">{{ card.id }}</span>
                    <span class="crm-prio-dot" [style.background]="prioridadeDoCard(card).cor"
                      [matTooltip]="'Prioridade ' + prioridadeDoCard(card).label"></span>
                    <span class="crm-card-footer-spacer"></span>
                    <!-- mousedown/touchstart param no botão: sem isso o cdkDrag do card começa a arrastar. -->
                    <button type="button" class="crm-icon-btn crm-fav-btn"
                      [class.crm-fav-btn--on]="card.isFavorito"
                      [disabled]="isFavoritando(card)"
                      [attr.aria-pressed]="card.isFavorito"
                      [attr.aria-label]="card.isFavorito ? 'Remover dos favoritos' : 'Favoritar'"
                      [matTooltip]="card.isFavorito ? 'Remover dos favoritos' : 'Favoritar'"
                      (mousedown)="$event.stopPropagation()"
                      (touchstart)="$event.stopPropagation()"
                      (click)="alternarFavorito(card); $event.stopPropagation()">
                      <mat-icon class="material-symbols-outlined" [class.crm-icon-filled]="card.isFavorito">star</mat-icon>
                    </button>
                    <button class="crm-icon-btn crm-card-menu-btn"
                      [matMenuTriggerFor]="cardMenu"
                      [matMenuTriggerData]="{ card: card }"
                      (click)="$event.stopPropagation()"
                      matTooltip="Ações">
                      <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
                    </button>
                  </div>

                  <div class="crm-card-cliente">
                    <mat-icon class="material-symbols-outlined">apartment</mat-icon>
                    <span class="crm-ellipsis">{{ card.cliente }}</span>
                  </div>

                  @if (card.contato) {
                    <div class="crm-card-contato">
                      <mat-icon class="material-symbols-outlined">person</mat-icon>
                      <span class="crm-ellipsis">{{ card.contato }}</span>
                    </div>
                  }

                  <div class="crm-card-title">{{ card.titulo }}</div>

                  @if (card.tags.length) {
                    <div class="crm-card-tags">
                      @for (tag of card.tags; track tag.idTagCrm) {
                        <span class="crm-tag" [style.color]="tag.cor"
                          [style.background]="tag.cor + '1A'"
                          [style.border-color]="tag.cor + '40'">{{ tag.descricao }}</span>
                      }
                    </div>
                  }

                  <!-- Divisor + rodapé -->
                  <div class="crm-card-footer">
                    @if (card.proximaAcao) {
                      <div class="crm-card-acao">
                        <mat-icon class="material-symbols-outlined">push_pin</mat-icon>
                        <span>{{ card.proximaAcao }}</span>
                      </div>
                    } @else {
                      <button type="button" class="crm-card-sem-acao"
                        (click)="definirProximaAcao(card); $event.stopPropagation()">
                        <mat-icon class="material-symbols-outlined">add_task</mat-icon>
                        Nenhuma ação definida
                      </button>
                    }

                    <div class="crm-card-footer-linha">
                      <span class="crm-status-icone" [style.color]="statusDoCard(card).cor"
                        [matTooltip]="statusDoCard(card).label">
                        <mat-icon class="material-symbols-outlined crm-icon-filled">person</mat-icon>
                      </span>

                      <span class="crm-card-valor" [matTooltip]="valorOrigem(card)">
                        <mat-icon class="material-symbols-outlined" [attr.aria-label]="valorOrigem(card)">{{ valorIcone(card) }}</mat-icon>
                        {{ valorLabel(card) }}
                      </span>

                      @if (card.dataProximaAcao) {
                        <span class="crm-card-data" [class.crm-card-data--overdue]="isAcaoVencida(card)"
                          matTooltip="Data da próxima ação">
                          @if (isAcaoVencida(card)) {
                            <mat-icon class="material-symbols-outlined">warning</mat-icon>
                          } @else {
                            <mat-icon class="material-symbols-outlined">event</mat-icon>
                          }
                          {{ card.dataProximaAcao }}
                        </span>
                      }

                      <span class="crm-card-footer-spacer"></span>

                      <span class="crm-avatar" [style.background]="card.respColor"
                        [matTooltip]="card.respName">
                        {{ card.resp }}
                      </span>
                    </div>
                  </div>
                  @if (idOportunidadeAbrindo === card.idOportunidade) {
                    <div class="crm-card-loading" aria-label="Abrindo oportunidade">
                      <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
                    </div>
                  }
                </div>
              }

              @if (estaCarregandoEtapa(stage.key)) {
                @for (slot of skeletonCards; track slot) {
                  <div class="crm-card crm-card--skeleton" aria-hidden="true">
                    <app-loading-box height="12" width="60%" margin="0 0 8px 0"></app-loading-box>
                    <app-loading-box height="12" width="90%" margin="0 0 8px 0"></app-loading-box>
                    <app-loading-box height="12" width="40%"></app-loading-box>
                  </div>
                }
              } @else if (temMaisNaEtapa(stage.key)) {
                <button mat-button type="button" class="btn-ver-mais crm-col-ver-mais"
                  (click)="carregarMaisDaEtapa(stage.key)">
                  <span class="material-symbols-outlined">expand_more</span> Ver Mais
                </button>
              }
            </div>
          </div>
        </ng-template>

        @if (etapasCarregando) {
          @for (col of skeletonColumns; track col) {
            <div class="crm-column crm-column--skeleton" aria-hidden="true">
              <div class="crm-col-accent crm-col-accent--skeleton"></div>
              <div class="crm-col-header">
                <app-loading-box height="28" width="28"></app-loading-box>
                <div class="crm-col-header-info">
                  <app-loading-box height="11" width="96" margin="0 0 5px 0"></app-loading-box>
                  <app-loading-box height="9" width="62"></app-loading-box>
                </div>
                <app-loading-box height="20" width="22"></app-loading-box>
              </div>
              <div class="crm-cards-area">
                @for (slot of skeletonCards; track slot) {
                  <ng-container [ngTemplateOutlet]="cardSkeleton"></ng-container>
                }
              </div>
            </div>
          }
        } @else if (!allStages.length) {
          <div class="crm-board-empty">
            <app-empty-list [title]="'Nenhuma etapa ativa no fluxo'"
              [subTitle]="'Configure as etapas em Configurações › Vendas › Configuração do Kanban de Oportunidades'">
            </app-empty-list>
          </div>
        } @else {
          @for (stage of mainStages; track stage.key) {
            <ng-container
              [ngTemplateOutlet]="isCollapsed(stage.key) ? colColapsada : colExpandida"
              [ngTemplateOutletContext]="{ $implicit: stage }"></ng-container>
          }

          @if (sideStages.length) {
            <div class="crm-board-divider"></div>

            @for (stage of sideStages; track stage.key) {
              <ng-container
                [ngTemplateOutlet]="isCollapsed(stage.key) ? colColapsada : colExpandida"
                [ngTemplateOutletContext]="{ $implicit: stage }"></ng-container>
            }
          }
        }

      </div>
    </div>
  }

  <!-- ===== LIST VIEW ===== -->
  @if (activeTab === 'lista') {
    <div class="crm-list-wrapper">
      @if (listaCards.length > 0) {
        <div class="crm-table-card">
          <table mat-table class="desktop-view" [dataSource]="listaCards" matSort
            [matSortActive]="listSortActive" [matSortDirection]="listSortDirection"
            (matSortChange)="onListSortChange($event)">

            <ng-container matColumnDef="cliente">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
              <td mat-cell *matCellDef="let card">
                <span class="crm-td-cliente">
                  <span class="crm-status-icone" [style.color]="statusDoCard(card).cor"
                    [matTooltip]="statusDoCard(card).label">
                    <mat-icon class="material-symbols-outlined crm-icon-filled">person</mat-icon>
                  </span>
                  <span>
                    <span class="crm-td-cliente-nome">{{ card.cliente }}</span>
                    @if (card.contato) {
                      <span class="crm-td-contato">{{ card.contato }}</span>
                    }
                  </span>
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="assunto">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Assunto</th>
              <td mat-cell *matCellDef="let card" class="crm-td-assunto">{{ card.titulo }}</td>
            </ng-container>

            <ng-container matColumnDef="etapa">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:200px">Etapa atual</th>
              <td mat-cell *matCellDef="let card">
                <span class="crm-stage-badge"
                  [style.color]="getStage(card.stage).color"
                  [style.background]="getStage(card.stage).tint"
                  [style.border-color]="getStage(card.stage).color + '33'">
                  <mat-icon class="material-symbols-outlined">{{ getStage(card.stage).icon }}</mat-icon>
                  {{ getStage(card.stage).name }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="responsavel">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:190px">Vendedor responsável</th>
              <td mat-cell *matCellDef="let card">
                <span class="crm-resp">
                  <span class="crm-avatar crm-avatar--sm" [style.background]="card.respColor">{{ card.resp }}</span>
                  {{ card.respName }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="proximaAcao">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Próxima ação</th>
              <td mat-cell *matCellDef="let card">
                @if (card.proximaAcao) {
                  <span class="crm-td-acao">{{ card.proximaAcao }}</span>
                } @else {
                  <button type="button" class="crm-td-sem-acao" (click)="definirProximaAcao(card)">
                    Nenhuma ação definida
                  </button>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="quando">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:130px">Quando</th>
              <td mat-cell *matCellDef="let card">
                @if (card.dataProximaAcao) {
                  <span class="crm-card-data" [class.crm-card-data--overdue]="isAcaoVencida(card)">
                    @if (isAcaoVencida(card)) {
                      <mat-icon class="material-symbols-outlined">warning</mat-icon>
                    }
                    {{ card.dataProximaAcao }}
                  </span>
                } @else {
                  <span class="crm-td--muted">—</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="tags">
              <th mat-header-cell *matHeaderCellDef style="width:200px">Tags</th>
              <td mat-cell *matCellDef="let card">
                @if (card.tags.length) {
                  <span class="crm-card-tags">
                    @for (tag of card.tags; track tag.idTagCrm) {
                      <span class="crm-tag" [style.color]="tag.cor"
                        [style.background]="tag.cor + '1A'"
                        [style.border-color]="tag.cor + '40'">{{ tag.descricao }}</span>
                    }
                  </span>
                } @else {
                  <span class="crm-td--muted">—</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="valor">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end" style="width:160px">Valor</th>
              <td mat-cell *matCellDef="let card" class="crm-td--value text-end">
                <span class="crm-td-valor" [matTooltip]="valorOrigem(card)">
                  <mat-icon class="material-symbols-outlined" [attr.aria-label]="valorOrigem(card)">{{ valorIcone(card) }}</mat-icon>
                  {{ valorLabel(card) }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="text-center w-actions crm-td-acoes">Ações</th>
              <td mat-cell *matCellDef="let card" class="text-center w-actions crm-td-acoes">
                <button mat-icon-button type="button" class="crm-fav-btn"
                  [class.crm-fav-btn--on]="card.isFavorito"
                  [disabled]="isFavoritando(card)"
                  [attr.aria-pressed]="card.isFavorito"
                  [attr.aria-label]="card.isFavorito ? 'Remover dos favoritos' : 'Favoritar'"
                  [matTooltip]="card.isFavorito ? 'Remover dos favoritos' : 'Favoritar'"
                  (click)="alternarFavorito(card); $event.stopPropagation()">
                  <span class="material-symbols-outlined" [class.crm-icon-filled]="card.isFavorito">star</span>
                </button>
                <button mat-icon-button aria-label="Ações"
                  [matMenuTriggerFor]="cardMenu"
                  [matMenuTriggerData]="{ card: card }"
                  (click)="$event.stopPropagation()">
                  <span class="material-symbols-outlined">more_horiz</span>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="listDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let card; columns: listDisplayedColumns"></tr>
          </table>
        </div>

        <div class="col-12 text-center mt-4 mb-5">
          <button mat-button class="btn-ver-mais" [disabled]="listaUltimaPagina || listaCarregando"
            (click)="carregarMaisCards()">
            <span class="material-symbols-outlined">expand_more</span>
            {{ listaCarregando ? 'Carregando…' : 'Ver Mais' }}
          </button>
        </div>
      } @else {
        <app-empty-list [title]="'Nenhuma oportunidade encontrada'"
          [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
      }
    </div>
  }

</div>
